import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 16px;
  margin-top: 16px;
  font-weight: 600;
`;

export const SubTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  //color: ${({ theme }) => theme.colors.primaryPurple};
`;

export const Paragraph = styled.p<{ $secondary?: boolean }>`
  font-size: 16px;
`;

// color: ${({ theme, $secondary }) => $secondary ? theme.colors.typographySecondary : theme.colors.black};
//color: ${({ theme }) => theme.colors.primaryPurple};
//color: ${({ theme }) => theme.colors.primaryPurpleDark};
